import useTestId from '@ori/testid-generator';
import { DiscountTagFilled, SuperdealFilled } from '@ori-ui/icons';
import { CatalogueOfferLabel } from "./CatalogueOfferLabel";
import { DealChip, Root } from "./styles";
import { LABEL_NEW, LABEL_OFFER, LABEL_SUPER_DEAL, NEW_EDITION_LABEL, NEW_EDITION_AVAILABLE_LABEL } from "../../common";
import { jsx as _jsx } from "react/jsx-runtime";
export var InnerDealLabel = function InnerDealLabel(_ref) {
  var label = _ref.label,
    type = _ref.type,
    catalogueLabel = _ref.catalogueLabel,
    catalogueUrl = _ref.catalogueUrl,
    offerLabelSmallerOnMobile = _ref.offerLabelSmallerOnMobile,
    productCode = _ref.productCode,
    tooltipTitle = _ref.tooltipTitle;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  if (type === 'Offer' && tooltipTitle) {
    return /*#__PURE__*/_jsx(CatalogueOfferLabel, {
      catalogueLabel: catalogueLabel,
      catalogueUrl: catalogueUrl,
      offerLabelSmallerOnMobile: offerLabelSmallerOnMobile,
      tooltipTitle: tooltipTitle,
      children: /*#__PURE__*/_jsx(Root, {
        isSuper: true,
        offerLabelSmallerOnMobile: offerLabelSmallerOnMobile,
        "data-testid": "".concat(getTestId(LABEL_OFFER), "-").concat(productCode),
        children: /*#__PURE__*/_jsx(DiscountTagFilled, {})
      })
    });
  }
  switch (type) {
    case 'Offer':
      return /*#__PURE__*/_jsx(Root, {
        isOffer: true,
        offerLabelSmallerOnMobile: offerLabelSmallerOnMobile,
        "data-testid": "".concat(getTestId(LABEL_OFFER), "-").concat(productCode),
        title: label !== null && label !== void 0 ? label : undefined,
        children: /*#__PURE__*/_jsx(DiscountTagFilled, {
          fontSize: "inherit"
        })
      });
    case 'SuperDeal':
      return /*#__PURE__*/_jsx(Root, {
        isSuper: true,
        offerLabelSmallerOnMobile: offerLabelSmallerOnMobile,
        "data-testid": "".concat(getTestId(LABEL_SUPER_DEAL), "-").concat(productCode),
        title: label !== null && label !== void 0 ? label : undefined,
        children: /*#__PURE__*/_jsx(SuperdealFilled, {
          fontSize: "inherit"
        })
      });
    case 'NewEditionAvailable':
      return /*#__PURE__*/_jsx(DealChip, {
        label: label,
        size: "small",
        "data-testid": "".concat(getTestId(NEW_EDITION_AVAILABLE_LABEL), "-").concat(productCode)
      });
    case 'NewEdition':
      return /*#__PURE__*/_jsx(DealChip, {
        label: label,
        size: "small",
        "data-testid": "".concat(getTestId(NEW_EDITION_LABEL), "-").concat(productCode)
      });
    case 'New':
      return /*#__PURE__*/_jsx(DealChip, {
        label: label,
        size: "small",
        "data-testid": "".concat(getTestId(LABEL_NEW), "-").concat(productCode)
      });
    default:
      return null;
  }
};
//# sourceMappingURL=InnerDealLabel.js.map